import { useState } from "react";

export function usePagination() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [jumpPage, setJumpPage] = useState("");

  const onLimitChange = (newLimit: number) => {
    setLimit(newLimit);
    setPage(1);
  };

  const onJump = (total: number) => {
    const n = Number(jumpPage);
    if (!Number.isFinite(n) || !n) return;
    const pageCount = Math.max(1, Math.ceil(total / limit));
    setPage(Math.min(Math.max(1, n), pageCount));
  };

  return { page, setPage, limit, onLimitChange, jumpPage, setJumpPage, onJump };
}

export type PaginationState = ReturnType<typeof usePagination>;
